module.exports = __webpack_public_path__ + "img/MFSShield.e58a0972.png";